import PhishingUseCaseIllustration from 'images/organization/features/malware/phising-use-case.svg'
import ProtectFinancialLossIllustration from 'images/organization/features/malware/protect-financial-loss.svg'
import EnsureProductivityIllustration from 'images/organization/features/malware/ensure-productivity.svg'
import MaintainSecurityIllustration from 'images/organization/features/malware/maintain-security.svg'
import { UseCaseItem } from 'components/Organization/Features/CommonSections/UseCases/FeatureUseCases'
import { CONTROLDText } from 'ui/CONTROLD'

export const analyticsUseCasesData: UseCaseItem[] = [
  {
    image: PhishingUseCaseIllustration,
    title: 'Proactive threat detection',
    text: `${CONTROLDText} identifies abnormal patterns that could indicate security threats. This allows you to take action before breaches occur, ensuring your business remains secure.`,
  },
  {
    image: ProtectFinancialLossIllustration,
    title: 'Optimize network performance',
    text: `Gain insights to identify bottlenecks and optimize performance. ${CONTROLDText}'s Analytics helps you ensure your network is running smoothly and efficiently.`,
  },
  {
    image: EnsureProductivityIllustration,
    title: 'Better decision making',
    text: `Use analytics to understand user behavior, allowing you to make informed decisions about access policies, security configurations, and productivity improvements.`,
  },
  {
    image: MaintainSecurityIllustration,
    title: 'Maintain security and compliance standards',
    text: `Meet compliance requirements by providing a clear audit trail of activity, demonstrating that your organization adheres to industry standards and regulations.`,
  },
]

export default analyticsUseCasesData
